import React, { useState, useRef, useEffect } from "react"
import style from "./style.module.scss"
// DB
import { q, adminClient } from "../../utils/fauna"

function Form({ openForm, setOpenForm }) {
  const [name, setName] = useState(undefined)
  const [email, setEmail] = useState(undefined)
  const [message, setMessage] = useState(undefined)
  const [done, setDone] = useState(false)
  const formRef = useRef()

  // Add message with addional info to db.
  const addToDb = () => {
    return new Promise(async (resolve, reject) => {
      try {
        await adminClient.query(
          q.Create(q.Collection("messages"), {
            data: {
              username: name,
              email,
              message,
            },
          })
        )
        resolve("Message is successfully added")
      } catch (error) {
        reject("Error occured: ", error)
      }
    })
  }

  const handleSubmit = async () => {
    try {
      addToDb()
      setDone(true)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (done) {
      setTimeout(() => {
        setOpenForm(false)
        setDone(false)
      }, 1000)
    }
  }, [done])

  return (
    <>
      {openForm &&
        (!done ? (
          <form
            method="post"
            className={style.form}
            ref={formRef}
            onSubmit={e => {
              e.preventDefault()

              handleSubmit()
            }}
            method="post"
          >
            <div className={style.name}>
              <label htmlFor="name">your name:</label>
              <input
                type="text"
                name="name"
                id="name"
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div className={style.email}>
              <label htmlFor="email">your email:</label>
              <input
                required
                type="email"
                name="email"
                id="email"
                onChange={e => setEmail(e.target.value)}
              />
            </div>
            <div className={style.message}>
              <label htmlFor="message">your message:</label>
              <textarea
                required
                rows="5"
                type="text"
                name="message"
                id="message"
                onChange={e => setMessage(e.target.value)}
              />
            </div>
            <div>
              <button type="submit">send</button>
            </div>
            <button
              type="button"
              className={style.close_btn}
              onClick={() => {
                formRef.current.style.animation = `${style.slideUp} 1s forwards`
                setTimeout(() => {
                  setOpenForm(false)
                }, 1000)
              }}
            >
              x
            </button>
          </form>
        ) : (
          <p className={style.thank_you_msg}>Thank you!</p>
        ))}
    </>
  )
}

export default Form
